export const Intro = {
  fontSize: {
    xs: '24px',
    md: '28px',
    xl: '34px'
  },
  lineHeight: {
    xs: '32px',
    md: '36px',
    xl: '42px'
  }
};